'use client';

import { Toaster } from '@shared/components/shadcn';
import { useParams, usePathname } from 'next/navigation';
import type { ToastProps } from './types';

function Toast({ position = 'bottom-right', className, ...props }: ToastProps) {
  const { gameid } = useParams();
  const pathname = usePathname();

  const offset = pathname.includes(gameid as string) ? { bottom: 92 } : undefined;

  return <Toaster position={position} className={className} offset={offset} mobileOffset={offset} {...props} />;
}

export { Toast };
